import { useState, useEffect } from "react";
import { AzilisSwitch } from "../Switch";
import { useTranslation } from "react-i18next";

const EditableResultSwitch = ({
  result,
  edit,
  setEdit,
  setValue,
  changed,
  styleNo,
  choice1,
  choice2,

  changeTo,
  autosave,
}) => {
  const [tempValue, setTempValue] = useState(changeTo);
  const { t } = useTranslation();
  // const [dropdown,setDropdown] = useState([])

  const handleEdit = () => {
    setEdit(true);
    setTempValue(changeTo);
  };
  const handleChange = (e) => {
    setTempValue(e.target.value);
  };

  const handleSaveChange = () => {
    setEdit(false);
    setValue(tempValue);
  };

  useEffect(() => {
    if (edit == true) {
      setTempValue(changeTo);
    }
  }, [edit]);

  useEffect(() => {
    if (autosave) {
      setValue(tempValue);
    }
  }, [tempValue]);
  return (
    <>
      {!edit ? (
        <h4 className={changed ? "__changed" : null}>{t(result)}</h4>
      ) : (
        <AzilisSwitch
          choice1={choice1}
          choice2={choice2}
          which={tempValue}
          setWhich={setTempValue}
          styleNo={styleNo}
        />
      )}
      {!edit ? (
        <>
          {/* <EditIcon style={{ marginLeft: 20, cursor: "pointer", color: "#476355" }} onClick={()=> handleEdit()}/> */}
        </>
      ) : (
        <>
          {/* Save changes */}
          {/* <CheckIcon style={{ marginLeft: 20, cursor: "pointer" }} onClick={() => handleSaveChange()}/> */}
          {/* Discard changes */}
          {/* <CloseIcon style={{ marginLeft: 8, cursor: "pointer" }} onClick={()=> setEdit(false)}/> */}
        </>
      )}
    </>
  );
};

export default EditableResultSwitch;
